import { api } from "@/lib/apiClient";

export type DashboardStat = {
  key: string;
  label: string;
  value: number;
  change: number;
  change_up: boolean;
};

export type DashboardTrendPoint = {
  day: string;
  date: string;
  primary: number;
  secondary: number;
};

export type DashboardRecentProduct = {
  id: number;
  name: string;
  subtitle: string;
  status_label: string;
  price: number | null;
  purchase_currency: string;
};

export type DashboardPayload = {
  stats: DashboardStat[];
  recent_products: DashboardRecentProduct[];
};

export type InventoryTrendRange = "month" | "last_7_days" | "custom";

export type InventoryTrendParams = {
  range: InventoryTrendRange;
  from?: string;
  to?: string;
};

export type InventoryTrendPayload = {
  trend: DashboardTrendPoint[];
  range: { from: string; to: string };
};

export async function fetchDashboard(): Promise<DashboardPayload> {
  const { data } = await api.get<{ data: DashboardPayload }>("/api/v1/dashboard");
  return data.data;
}

export async function fetchInventoryTrend(params: InventoryTrendParams): Promise<InventoryTrendPayload> {
  const { data } = await api.get<{ data: InventoryTrendPayload }>("/api/v1/dashboard/inventory-trend", {
    params: {
      range: params.range,
      from: params.range === "custom" ? params.from : undefined,
      to: params.range === "custom" ? params.to : undefined,
    },
  });
  return data.data;
}
